module.exports = __webpack_public_path__ + "static/img/blue-house.b10ff3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/blue-house.jpg
// module id = +PN/
// module chunks = 0